import { useContext, useEffect, useState } from "react"
import Navbar from "./navbar"
import { SearchNewForPage } from "./search_new_page"
import DogCard from "./dog_card"
import { dogUrlGenerator } from '../../util.js/dogUrlGenerator';
import dogpic from './images/logo1.jpg'
import { Link } from "react-router-dom";
import CountryContext from "./country_context";


export const SearchPage = () => {
    const context = useContext(CountryContext)
    // useEffect(()=>{
    //     render_dog_list()
    // }, [dogs])
    const [dogs, setDogs] = useState([])

    const render_dog_list = () => {
        if (dogs) {
            return dogs.map((dog) => (
                <div className=' col-10 col-md-6 col-lg-3 
                 text-capitalize render_card'>
                    <Link to={`/my_dogs/${dog.id}/${dogUrlGenerator(dog.name)}`}>
                        <DogCard image_src={dogpic} dog_id={dog.id}
                            dogname={dog.name} dog_public_id={dog.public_id}
                            date_registered={dog.date_registered} />
                    </Link>
                </div>
            ))
        }

    }

    return (
        <div className="container-fluid">
            <Navbar />
            <div className="profile-body-light pb-5 ">
                {context.user ?
                    <div>
                        <div class="row align-items-center justify-content-center py-5">
                            <div className="col-md-6"> <SearchNewForPage
                                dogs={dogs} setDogs={setDogs} /></div >
                        </div>
                        <div className="row align-items-start justify-content-center">
                            {render_dog_list()}
                        </div>
                        <div class="row align-items-center justify-content-center">
                            <div className="col-md-6 border border-dark-top">
                                <p className="py-5">Search for a dog to display results</p>
                            </div>
                        </div>
                    </div>
                    :
                    <div className="view_height_100 d-flex
                     align-items-center justify-content-center">
                        <div className='py-5 py-sm-0 mt-2 mt-sm-0 ' >
                            <div className='row align-items-center justify-content-center py-5 my-0 my-sm-5'>

                                <div className='col-md-10 text-left text-md-left py-5 mx-5 mx-sm-0'>
                                    <h1 className='font-weight-normal 
                            text-dark mt-5 mt-sm-0 mb-5 mb-sm-0 '>
                                        <span className='text-warning '>  Oops!!!</span> Sorry this feature is 
                                        only available for registered users</h1>
                                 
                                    <small>
                                        <li class="d-inline ">
                                            <Link class="" to="/login">Login&nbsp;&nbsp;&nbsp;</Link>
                                            <Link class="" to="/sign_up">Sign up&nbsp;&nbsp;&nbsp;</Link>

                                            <Link class="" to="/home">Home</Link>

                                        </li>
                                    </small>

                                    {/* <p className='mt-0 mt-sm-5 '><small>The African Bully Registry</small></p> */}
                                </div>
                            </div>
                        </div>                    </div>
                }

            </div>

        </div>
    )
}